import script from "./PaymentServiceInstruction.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentServiceInstruction.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentServiceInstruction.vue?vue&type=style&index=0&id=10c7b086&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c7b086"]])

export default __exports__